
import React from "react";
import AwardListTable from "./components/AwardListTable";
import AddItemBtn from "Common/Custom/AddItemBtn";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const AwardList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Award List</HeadingOne>
                    <AddItemBtn url="add-award" title="Add Award" />
                </>
            }
        >
            <div className="col-12">
                <AwardListTable />
            </div>
        </PageBody>
    );
};

export default AwardList;
